import { useMutation, useQueryClient } from '@tanstack/react-query';
import { apiClient } from '@/api/client';
import { API_NOTICE_HIDE } from '@/api/endpoints';
import { NOTICE_QUERY_KEY } from '@/api/queryKeys';
import { ErrorMessage, logRequestError } from '@/utils/errors';

interface UseHideDashboardNoticeResult {
  hide: (id: number) => Promise<void>;
  isPending: boolean;
}

export const useHideDashboardNotice = (): UseHideDashboardNoticeResult => {
  const queryClient = useQueryClient();

  const { mutateAsync, isPending } = useMutation({
    mutationFn: (id: number) =>
      apiClient.post(API_NOTICE_HIDE, null, {
        params: { id },
      }),
  });

  const hide = async (id: number): Promise<void> => {
    if (isPending) {
      return;
    }

    try {
      await mutateAsync(id);
      queryClient.setQueryData(NOTICE_QUERY_KEY, null);
    } catch (error) {
      logRequestError(ErrorMessage.HideDashboardNotice, error);
    }
  };

  return { hide, isPending };
};
